<template>
    <div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    style="margin-left: 10px;"
                    placeholder="员工名称"
                    v-model="searchValue"
                    @search="search"
                ></table-searcher>
            </template>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="customer.list"
            :loading="loading"
            :height="mtHeight"
            :highlight-row="!multiple"
            @on-current-change="selectChange"
            @on-select="onSelect"
            @on-select-cancel="onSelectCancel"
            @on-select-all="onSelectAll"
            @on-select-all-cancel="onSelectAllCancel"
        ></Table>
        <!-- 分页栏 -->
        <table-pager
            :total.sync="customer.total"
            :pageSize.sync="customer.pageSize"
            :pageNo.sync="customer.page"
            placement="top"
            transfer
        ></table-pager>
    </div>
</template>
<script>
import { userList } from '@/api/sys-user'
import { type } from '_u/helper'
import Enum from '_u/enum'
import { mapCell } from '_c/grid/renderCell'

const WINDOW_HEIGHT = document.body.clientHeight
const PAGE_SIZE = 20

export default {
    name: 'assessSelectCustomer',
    components: {},
    inject: {
        $modal: { default: null }
    },
    props: {
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            searchValue: '',
            mtHeight: 330,
            customer: {
                page: 1,
                pageSize: PAGE_SIZE,
                total: 0,
                list: []
            },
            rowId: '',
            selection: [],
            orgList: []
        }
    },
    computed: {
        columns() {
            var cols = [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'nickname',
                    title: '姓名',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'phone',
                    title: '手机号',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'roleName',
                    title: '岗位',
                    align: 'left',
                    minWidth: 120
                }
            ]

            // 多选
            if (this.multiple) {
                cols.unshift({
                    type: 'selection',
                    width: 60,
                    align: 'center'
                })
            }

            return cols
        }
    },
    methods: {
        fetch() {
            this.loading = true
            var body = {
                page: this.customer.page,
                pageSize: this.customer.pageSize,
                nickname: this.searchValue
            }
            return userList(body)
                .then(res => this.setCustomerData(res.data))
                .finally(() => this.loading = false)
        },
        search() {
            this.customer.page = 1
            this.fetch()
        },
        setCustomerData(data) {
            this.customer.total = parseInt(data.page.totalCount)
            // 默认选中逻辑
            if (this.multiple) {
                data.page.list.forEach(row => {
                    if (this.selection.find(el => el.id == row.id)) {
                        return (row._checked = true)
                    }
                })
            } else {
                data.page.list.some(row => {
                    if (this.selection.find(el => el.id == row.id)) {
                        return (row._highlight = true)
                    }
                })
            }

            var dataList = data.page.list || []

            this.customer.list = dataList
            this.loading = false
        },
        fillData(args) {
            var [customer] = args
            this.setCustomerData(customer.data)
        },
        selectChange(selection) {
            if (type(selection) != 'array') {
                selection = [selection]
            }
            this.selection = selection
        },
        onSelect(selection, item) {
            this.selection.push(item)
        },
        onSelectCancel(selection, item) {
            this.selection.splice(
                this.selection.findIndex(el => el.id == item.id),
                1
            )
        },
        onSelectAll(selection) {
            let arr = JSON.parse(JSON.stringify(selection))
            this.selection.forEach(el => {
                if (arr.find(val => val.id == el.id)) {
                } else {
                    selection.push(el)
                }
            })
            this.selection = selection
        },
        onSelectAllCancel(selection) {
            let arr = JSON.parse(JSON.stringify(this.selection))
            arr.forEach(el => {
                if (this.customer.list.find(val => val.id == el.id)) {
                    el.flag = true
                } else {
                }
            })
            this.selection = arr.filter(el => !el.flag)
        }
    },
    created() {
        let that = this
        that.$modal.$on('lookup-open', data => {
            that.selection = []
            data.forEach(v => {
                that.selection.push({
                    id: v.value,
                    nickname: v.text,
                })
            })
            // 打开选择框
            that.$modal.beforeEnter(next => {
                that.fetch().then(res => next())
            })

            // 关闭选择框
            that.$modal.onBtnClick('confirm', (next, options) => {
                // todo 返回默认选中的项目
                that.$modal.$emit('lookup-close', that.selection)
                next()
            })
        })
    },
    mounted() {
        var me = this

        this.$watch(
            function() {
                return this.customer.page + ' ' + this.customer.pageSize
            },
            function() {
                this.fetch()
            }
        )
    }
}
</script>
